export const tools = [
  { to: '/image-resizer', icon: '↔', name: 'Image Resizer', detail: 'Resize by pixels or percent' },
  { to: '/image-compressor', icon: '◌', name: 'Image Compressor', detail: 'Reduce file size locally' },
  { to: '/webp-to-jpg', icon: 'W', name: 'WebP to JPG', detail: 'Convert browser-side' },
  { to: '/png-to-jpg', icon: 'PNG', name: 'PNG to JPG', detail: 'Convert PNG files to JPG' },
  { to: '/jpg-to-png', icon: 'JPG', name: 'JPG to PNG', detail: 'Convert JPG files to PNG' },
  { to: '/jpg-to-pdf', icon: 'PDF', name: 'JPG to PDF', detail: 'Combine images into a PDF' },
  { to: '/merge-pdf', icon: '+', name: 'Merge PDF', detail: 'Combine PDF files in order' },
  { to: '/split-pdf', icon: '✂', name: 'Split PDF', detail: 'Create separate PDF files' },
  { to: '/rotate-pdf', icon: '↻', name: 'Rotate PDF', detail: 'Rotate all or selected pages' },
  { to: '/remove-pdf-pages', icon: '−', name: 'PDF Page Cleaner', detail: 'Create a PDF without selected pages' },
];
